import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';

const setMessageAdListResetPropertiesMutator: (
    refreshAfterDeleteInterval: number,
    isSuperClicker: boolean
) => void = mutatorAction(
    'setMessageAdListResetProperties',
    function (refreshAfterDeleteInterval: number, isSuperClicker: boolean): void {
        const store = getStore();
        if (store) {
            store.refreshAfterDeleteInterval = refreshAfterDeleteInterval;
            store.isSuperClicker = isSuperClicker;
        }
    }
);
export default setMessageAdListResetPropertiesMutator;
